import React, { useState } from 'react';
import { HelpCircle, MapPin, Smartphone, Sparkles } from 'lucide-react';

const Detail = ({ label, children, highlight }) => (
  <section className={`rounded-xl border p-4 ${highlight ? 'border-yellow-400 bg-yellow-500/10' : 'border-gray-800 bg-gray-900'}`}>
    <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-purple-300">{label}</h3>
    <div className="mt-2 text-base leading-7 text-gray-100">{children}</div>
  </section>
);

export default function FilmingCard({ clip, index, total, onFilmed }) {
  const [help, setHelp] = useState(false);
  return (
    <div className="mx-auto max-w-xl">
      <p className="text-center text-xs font-bold uppercase tracking-[0.2em] text-purple-300">Clip {index + 1} of {total}</p>
      <h2 className="mt-2 text-center text-3xl font-bold text-white">{clip.title}</h2>
      {help && <div role="status" className="mt-5 rounded-xl border border-yellow-400/50 bg-yellow-500/10 p-4 text-center text-yellow-100"><strong>Only focus on this clip.</strong><br />Start with the highlighted action below.</div>}
      <div className="mt-6 space-y-3">
        <Detail label="Where"><span className="inline-flex items-center gap-2"><MapPin size={18} className="text-purple-300" />{clip.location}</span></Detail>
        <Detail label="Phone"><span className="inline-flex items-start gap-2"><Smartphone size={18} className="mt-1 shrink-0 text-purple-300" />{clip.phonePosition}</span></Detail>
        <Detail label="Show">{clip.frame}</Detail>
        <Detail label="Start Position">{clip.startPosition}</Detail>
        <Detail label="Do This" highlight={help}>
          <ol className="space-y-3">
            {clip.steps.map((step, stepIndex) => <li key={`${stepIndex}-${step}`} className="flex gap-3"><span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-purple-600 text-sm font-bold">{stepIndex + 1}</span><span>{step}</span></li>)}
          </ol>
        </Detail>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <Detail label="Look">{clip.eyes}</Detail>
          <Detail label="Expression"><span className="inline-flex items-center gap-2"><Sparkles size={17} className="text-purple-300" />{clip.expression}</span></Detail>
        </div>
        <Detail label="Record For"><strong className="text-white">{clip.duration}</strong></Detail>
      </div>
      <button onClick={onFilmed} className="mt-6 min-h-14 w-full rounded-xl bg-purple-600 px-5 py-3 font-bold hover:bg-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-300">I'VE FILMED THIS</button>
      <button onClick={() => setHelp((value) => !value)} className="mt-2 inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-xl text-sm font-semibold text-gray-300 hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-purple-300"><HelpCircle size={18} /> I NEED HELP</button>
    </div>
  );
}
